var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.31577 15.9043C7.92399 16.1746 7.50866 15.8337 7.56764 15.3645L7.73216 14.0556C6.02682 13.851 4.81412 12.3348 5.02351 10.6689C5.2329 9.00306 6.78509 7.81842 8.49042 8.02296C10.1958 8.22751 11.4085 9.74377 11.1991 11.4096C10.9742 13.1983 9.51332 15.078 8.31577 15.9043ZM16.0932 15.9043C15.7014 16.1746 15.2861 15.8337 15.3451 15.3645L15.5096 14.0556C13.8042 13.851 12.5915 12.3348 12.8009 10.6689C13.0103 9.00306 14.5625 7.81842 16.2678 8.02296C17.9732 8.22751 19.1859 9.74377 18.9765 11.4096C18.7517 13.1983 17.2907 15.078 16.0932 15.9043Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteAlt1);
export default __webpack_public_path__ + "static/media/quote-alt-1.4081c6143f4c18751f9e0f5172c17f40.svg";
export { ForwardRef as ReactComponent };